import {useEffect} from 'react';
import {useCMSBuilder} from '../contexts/CMSBuilderContext';
import {useForm, usePlugin} from 'tinacms';
import {usePageSave} from './usePageServer';


export const usePageCms = (id, page) => {
  const {setForm} = useCMSBuilder();
  const {mutate} = usePageSave(id);
  // 2. Define the form configuration object
  const formConfig = {
    id,
    label: 'Edit Page',
    fields: [
      {
        name: 'title',
        label: 'Title',
        component: 'text',
      },
      {
        name: 'body',
        label: 'Body',
        component: 'textarea',
      },
    ],
    initialValues: page?.content,
    onSubmit: async (values) => {
      mutate({
        _id: page._id,
        content: values
      });
    },
  };

  // 1. Create the form
  const [data, form] = useForm(formConfig);

  // 2. Register it with the CMS
  usePlugin(form);

  // 3. Register it in the builder
  useEffect(() => {
    setForm(form);
  }, [form, setForm]);

  return {form, data};
};

